import QueryBuilder from "../helpers/QueryBuilder";
import SupplyService from "../services/SupplyService";

const state = {
  supplies: [],
  queryFilters: {
    name: "",
    page: 0,
    size: 10,
    sortBy: "name"
  },
  loading: false,
  totalPages: 1
};

const mutations = {
  setSupplies(state, supplies) {
    state.supplies = supplies;
  },
  setTotalPages(state, totalPages) {
    state.totalPages = totalPages;
  },
  setQueryFilters(state, queryItem) {
    state.queryFilters = queryItem;
  },
  resetFilters(state) {
    state.queryFilters.page = 0;
    state.queryFilters.name = "";
  },
  setPage(state, page) {
    state.queryFilters.page = page;
  },
  toggleLoading(state, payload) {
    state.loading = payload;
  }
};
const actions = {
  getSupplies({ commit, state }) {
    commit("toggleLoading", true);
    const queryString = QueryBuilder.getQueryString(state.queryFilters);
    SupplyService.getSupplies(queryString).then(({ data }) => {
      commit("setTotalPages", data.totalPages);
      commit("setSupplies", data.content);
      commit("toggleLoading", false);
    });
  },
  createSupply({ commit, state }, supply) {
    return new Promise((resolve, reject) => {
      SupplyService.create(supply).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  editSupply({ commit, state }, supply) {
    return new Promise((resolve, reject) => {
      SupplyService.update(supply).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  removeSupply({ commit, state }, supplyId) {
    return new Promise((resolve, reject) => {
      SupplyService.remove(supplyId).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
